import React, {Component} from "react"
import {Container, Divider, Header, Loader, Segment, Table} from "semantic-ui-react";
import {Redirect, withRouter} from "react-router-dom";
import {getLocalization, interpolateString,} from "../utils/localization";
import {connect} from "react-redux";
import {checkIsOpenEnrollment, formatMoneyAmount, getEnrollmentTimezone, getTranslatedCoverageText, NOT_IN_OPEN_ENROLLMENT_ROUTE} from "../utils/common";
import 'rc-slider/assets/index.css';
import Footer from "./footer";
import moment from "moment";
import 'moment-timezone';
import GetHelpModal from "./getHelpModal";
import {getChronicRiderLabel, getMaternityRiderLabel, getMentalRiderLabel} from "../utils/riders";
import {ClickableText, CustomGrid} from "./custom-common";
import {PrepareSummaryRequest} from "../services/types";
import {prepareSummaryService} from "../services/services";

const mapStateToProps = (state, ownProps) => {
    const { user, initialData, benAdmin } = state;
    const { openEnrollment, payrollFrequencySelected, riderLabels, ratedClass } = initialData;

    const contractTerms = ratedClass?.contractTerms || {};
    const additionalChronic = contractTerms?.chronicBrokerRequested ? contractTerms.chronicCoverageLimit : 0;
    const additionalMental = contractTerms?.mentalBrokerRequested ? contractTerms.mentalCoverageLimit : 0;
    const additionalMaternity = contractTerms?.maternityBrokerRequested ? contractTerms.maternityCoverageLimit : 0;

    const isBrellaChoice = !!initialData && !!initialData.contractInfo && initialData.contractInfo.planOffering === "Brella Choice";

    const {enrollmentStartDate, enrollmentEndDate} = openEnrollment;
    const start = moment(enrollmentStartDate);
    const end = moment(enrollmentEndDate);
    const isOpenEnrollment = checkIsOpenEnrollment(start, end, getEnrollmentTimezone(initialData));

    const isMonthly = payrollFrequencySelected === initialData.payrollFrequencyMonthly;
    let costPerOption = "Paycheck";
    if(isMonthly){
        costPerOption = 'Month';
    }
    return {
        ...ownProps,
        additionalChronic,
        additionalMental,
        additionalMaternity,
        isBrellaChoice,
        user,
        initialData,
        isOpenEnrollment,
        benAdmin,
        riderLabels,
        effectiveDate: moment(initialData.policy.polEDate, "YYYY-MM-DD").toISOString(),
        moderateIncrements: (!!initialData && !!initialData.increments && initialData.increments.moderate) || [],
        severeIncrements: (!!initialData && !!initialData.increments && initialData.increments.severe) || [],
        catastrophicIncrements: (!!initialData && !!initialData.increments && initialData.increments.catastrophic) || [],

        lang: user.lang,
        costPerOptions: initialData.costPerOptions,
        costPerOption: costPerOption,
        coverageOptions: initialData.coverageOptions,
    }
};

class SummaryReturningUser extends Component {
    constructor(props) {
        super(props);
        this.state = {
            displayGetHelpModal: false,
            loading: false,
            error: false,
            cost: 0,
            moderateCoverageSelected: 0,
            severeCoverageSelected: 0,
            catastrophicCoverageSelected: 0,
            displayTier: null,
            effectiveDate: null,
            familyTier: null,
        };
    }

    componentDidMount() {
        this.prepareSummary().then();
    }

    prepareSummary = async () => {
        try {
            const {initialData:{token}} = this.props;
            this.setState({
                loading: true,
                error: false,
            });
            const payload = new PrepareSummaryRequest({token});
            const result = await prepareSummaryService(payload);
            if(!!result && !!result.data) {
                const data = result.data;
                const {
                    employerContribution,
                    certificate: {
                        effectiveDate,
                        familyTier,
                    },
                    cost,
                    benefits: {
                        catastrophic, moderate, severe,
                    }
                } = data;

                this.setState({
                    loading: false,
                    effectiveDate,
                    familyTier,
                    employerContribution: !!employerContribution? employerContribution : 0,
                    cost: cost,
                    moderateCoverageSelected: moderate,
                    severeCoverageSelected: severe,
                    catastrophicCoverageSelected: catastrophic,
                });
            } else {

                this.setState({
                    loading: false,
                    error: true,
                });
            }
        } catch(e){
            console.log({e});
            this.setState({
                loading: false,
                error: true,
            });
        }
    }


    render() {
        const {
            loading,
            displayGetHelpModal,
            cost,
            moderateCoverageSelected,
            severeCoverageSelected,
            catastrophicCoverageSelected,
            effectiveDate,
            employerContribution,
            familyTier,
        } = this.state;

        const {
            lang,
            additionalChronic,
            additionalMental,
            additionalMaternity,
            isOpenEnrollment,
            initialData,
            costPerOption,
            costPerOptions,
            coverageOptions,
            riderLabels
        } = this.props;

        const localization = getLocalization(lang);
        const strings = localization.summary;
        let displayAgeReduction = false;
        const {ageReduction, ageReductionAge, ageReductionPercentage} = initialData.policy;
        if(ageReduction){
            const age = initialData.ageAtPolicyEffectiveDate;
            if(age >= ageReductionAge){
                displayAgeReduction = true;
            }
        }

        let displayTier = "";
        const filtered = coverageOptions.filter((co)=> co.value === familyTier);
        if (!!filtered && filtered.length > 0) {
            displayTier = getTranslatedCoverageText(filtered[0].value, getLocalization(lang));
        }

        const costPayment = !!costPerOptions && costPerOptions.filter((cpo) => cpo.value === costPerOption)[0].value;
        const formattedCostPayment = costPayment === "Month" ? strings.mo : strings.paycheck.toLowerCase();

        const hasElections = false; // TODO: When phone is implemented this can't be hardcoded

        if(loading){
            return <Loader active>Loading</Loader>
        }

        const riders = [
            { value: additionalChronic, label: getChronicRiderLabel(strings, riderLabels) },
            { value: additionalMental, label: getMentalRiderLabel(strings, riderLabels) },
            { value: additionalMaternity, label: getMaternityRiderLabel(strings, riderLabels) },
        ].filter(({ value }) => value > 0);

        return (
            <React.Fragment>
                <GetHelpModal localization={localization} uiFlow={initialData.uiFlow}
                              employerId={!!initialData && !!initialData.employer && initialData.employer.id}
                              onModalClose={() => this.setState({displayGetHelpModal: false})}
                              displayCoveredModal={displayGetHelpModal}
                />
                <Container className={'contentContainer'}>
                    <CustomGrid container stackable columns={1} centered fitted={'horizontally'}>
                        <CustomGrid.Column width={8}>
                            <Header as="h2">{strings.title}</Header>
                            <p>{strings.description}</p>

                            {!!displayAgeReduction && <React.Fragment>
                                <Divider hidden/>
                                <Segment basic className={"bkgLinen small"}>
                                    <b>{strings.important}</b>: {interpolateString(strings.basedOn, [ageReductionPercentage])}
                                </Segment>
                                <Divider hidden/>
                            </React.Fragment>}

                            <Segment style={{padding: '3em', marginBottom: '0', boxShadow: 'unset'}}>
                                <CustomGrid columns={2}>
                                    <CustomGrid.Column>
                                        <CustomGrid.Row>
                                            <div className="small neutral600Text"><b>{strings.benefitAmounts}</b></div>
                                            <Table basic={'very'} style={{marginTop: 0}}>
                                                <Table.Body>
                                                    <Table.Row>
                                                        <Table.Cell><b>{strings.moderate}</b></Table.Cell>
                                                        <Table.Cell>${formatMoneyAmount(moderateCoverageSelected)}</Table.Cell>
                                                    </Table.Row>
                                                    <Table.Row>
                                                        <Table.Cell><b>{strings.severe}</b></Table.Cell>
                                                        <Table.Cell>${formatMoneyAmount(severeCoverageSelected)}</Table.Cell>
                                                    </Table.Row>
                                                    <Table.Row>
                                                        <Table.Cell><b>{strings.catastrophic}</b></Table.Cell>
                                                        <Table.Cell>${formatMoneyAmount(catastrophicCoverageSelected)}</Table.Cell>
                                                    </Table.Row>
                                                </Table.Body>
                                            </Table>

                                            {employerContribution > 0 && <React.Fragment>
                                                <div className="small neutral600Text" style={{marginBottom: '0.4em'}}>
                                                    <b>{strings.employerContrib}</b></div>
                                                <b>${formatMoneyAmount(employerContribution)}</b>
                                            </React.Fragment>
                                            }

                                            <div style={{marginTop: '1em'}}>
                                                <div className="small neutral600Text" style={{marginBottom: '0.4em'}}>
                                                    <b>{strings.whosCovered}</b></div>
                                                <b>{displayTier}</b>
                                            </div>
                                        </CustomGrid.Row>
                                    </CustomGrid.Column>

                                    <CustomGrid.Column>
                                        <CustomGrid.Row>
                                            {riders.length > 0 && (
                                                <>
                                                    <div className="small neutral600Text">
                                                        <b>{strings.additionalCoverage}</b>
                                                    </div>
                                                    <Table basic="very" style={{ marginTop: 0 }}>
                                                        <Table.Body>
                                                            {riders.map(({ value, label }, idx) => (
                                                                <Table.Row key={idx}>
                                                                    <Table.Cell><b>{label}</b></Table.Cell>
                                                                    <Table.Cell>${value}</Table.Cell>
                                                                </Table.Row>
                                                            ))}
                                                        </Table.Body>
                                                    </Table>
                                                </>
                                            )}
                                            <div className="small neutral600Text" style={{marginBottom: '0.4em'}}>
                                                <b>{strings.effectiveDate}</b>
                                            </div>
                                            <b>{moment(effectiveDate).format("MMM DD, YYYY")}</b>

                                            <div style={{marginTop: '1em'}}>
                                                <div className="small neutral600Text" style={{marginBottom: '0.4em'}}>
                                                    <b>{strings.yourCost}</b>
                                                </div>
                                                <b>${formatMoneyAmount(cost)} / {formattedCostPayment}</b>
                                            </div>
                                        </CustomGrid.Row>
                                    </CustomGrid.Column>
                                </CustomGrid>
                            </Segment>
                           <div className={'summaryReviewNote'}>
                               <b>{strings.note}: </b>
                                   {isOpenEnrollment ? (
                                       <span>{strings.youveAlready}
                                           <ClickableText onClick={()=>{this.setState({displayGetHelpModal: true,})}}>
                                                  {strings.reachOut}</ClickableText>
                                       </span>
                                   ):(
                                       hasElections ? (
                                           <span>{strings.youllReceive}</span>
                                       ):(
                                           <Redirect to={NOT_IN_OPEN_ENROLLMENT_ROUTE}/>
                                       )
                                   )}
                           </div>
                        </CustomGrid.Column>
                    </CustomGrid>
                </Container>

                <Footer showTopFooter={false} showCenterData={true}/>
            </React.Fragment>
        )
    }
}

export default withRouter(connect(mapStateToProps)(SummaryReturningUser));
